import "../../challenges/Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import CustomDropdown from "../../../../components/ModelsDropdown"
import SelectDropdown from "components/DropdownSelect";
import Loader from "components/loader";


const fileTypes = ["JPG", "PNG", "WEBP" , "JPEG"];
const presentationTypes = ["PPTX"];

const AddProject = () => {
  const [img, setImg] = useState(null);
  const [cover, setCover] = useState(null);
  const [model3D, setModel3D] = useState([]);
  const [presentation, setPresentation] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [coverLoading, setCoverLoading] = useState(false);
  const [preLoading, setPreLoading] = useState(false);

const curriculaTypes = [ {name: "IB"}, {name: "IG" }, {name: "American" }];
        const [formInputs , setFormInputs] = useState({
          projectName:"",
          subject:"",
          grade:"",
          lesson:"",
          introduction:"",
          ngssCross:"",
          materialNeeded:"",
          keyVocabulary:"",
          optionalExtras:"",
          studentObjectives:"",
          studentSteps:"",
          teacherObjectives:"",
          teacherSteps:"",
          assessmentOptions:"",
          hintsTips:"",
          model3dId:"",
          model3dName:"",
          curricula:"",
        });

      const success = () => {
           message.success('Your Project created successfully');
          };

    const successPhoto = () => {
           message.success('Image uploaded successfully');
          };
    const successPresentation = () => {
           message.success('Presentation uploaded successfully');
          };
    const errorMessage = (error) => {
           message.error(error || 'Something went wrong');
          }

        const isFormValid = formInputs.projectName.trim() !== '' && formInputs.subject.trim() !== '' 
         && formInputs.grade.trim() !== '' && formInputs.lesson.trim() !== '' && formInputs.curricula.trim() !== ''; 
       
        const handleImgChange = async (img) => {
          setCardLoading(true);
          const formData = new FormData();
          formData.append('img', img);
          console.log('Uploaded file:', img);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCardLoading(false);
                                  successPhoto();
                                  setImg(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

      const handleCoverChange = async (cover) => {
        setCoverLoading(true);
        const formData = new FormData();
          formData.append('img', cover);
          console.log('Uploaded file:', cover);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCoverLoading(false);
                                  successPhoto();
                                    setCover(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

    const handlePresentation = async (pptx) => {
          setPreLoading(true);
          const formData = new FormData();
          formData.append('pptx', pptx);
          console.log('Uploaded file:', pptx);
           await api.post(`${API_BASE_URL}attachment/pptx`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                      console.log("handlesubmitffff  ", response.data)
                                  successPresentation();
                                  setPresentation(response.data);
                                  setPreLoading(false);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
  };

    const handleSubmit = (event) => {
    event.preventDefault();
      submitForm();
    }

         const submitForm = async () => {
      if(img && cover)  await api.post(`${API_BASE_URL}projects`,{
          projectName: formInputs.projectName,
          subject: formInputs.subject,
          grade: formInputs.grade,
          lesson: formInputs.lesson,
          introduction: formInputs.introduction,
          ngssCross: formInputs.ngssCross,
          materialNeeded: formInputs.materialNeeded,
          keyVocabulary: formInputs.keyVocabulary,
          optionalExtras: formInputs.optionalExtras,
          studentObjectives: formInputs.studentObjectives,
          studentSteps: formInputs.studentSteps,
          teacherObjectives: formInputs.teacherObjectives,
          teacherSteps: formInputs.teacherSteps,
          assessmentOptions: formInputs.assessmentOptions,
          hintsTips: formInputs.hintsTips,
          model3d: formInputs.model3dId,
          img: img? img.id : null,
          cover: cover? cover.id : null,
          presentation: presentation? presentation.id : null,
          curricula: formInputs.curricula,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  success();
          setFormInputs({
          projectName:"",
          subject:"",
          grade:"",
          lesson:"",
          introduction:"",
          ngssCross:"",
          materialNeeded:"",
          keyVocabulary:"",
          optionalExtras:"",
          studentObjectives:"",
          studentSteps:"",
          teacherObjectives:"",
          teacherSteps:"",
          assessmentOptions:"",
          hintsTips:"", 
          model3dId:"",
          model3dName:"",
          curricul:"",
        })
        setImg(null);
        setCover(null);
        setPresentation(null);
        
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
          errorMessage(error.response?.data?.massage);
        });
            
          }

useEffect(() => {
     api.get(`${API_BASE_URL}projects-3dmodel/prodropdown`)
      .then((response) => {  
        setModel3D(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, []);

// const models = ()=> { 
//   let oppmodels =[]
//   for (let i = 0; i < model3D.length; i++) {
//  oppmodels.push(<option value={model3D[i].id} >{model3D[i].modelName}</option>)
//  }
//  return oppmodels
// }
 const newModel = (e)=>{
  setFormInputs({...formInputs, model3dId: e.id, model3dName: e.modelName})
}


  return (
   <form className="addChallenge mb-[100px]" onSubmit={handleSubmit}>
    <h2>Add New Project</h2>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
          <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label for="challengeTitle">Project name</label>
            <input type="text" className="inputWidth" id="projectName" value={formInputs.projectName} placeholder="Enter Project name" 
            onChange={(e) =>setFormInputs({...formInputs, projectName: e.target.value})}/>
          </div>
            <div className="addCHInpts">
            <label for="gradeLevel">Grade level</label>
            <input type="number" className="inputWidth" id="gradeLevel" value={formInputs.grade} placeholder="Enter Grade level"
                onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }}}
             onChange={(e) =>setFormInputs({...formInputs, grade: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="introduction">Introduction</label>
            <textarea type="text" className="inputWidth" id="introduction" value={formInputs.introduction} placeholder="Enter Introduction"
             onChange={(e) =>setFormInputs({...formInputs, introduction: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="designGuidelines">Material needed</label>
            <textarea type="text" className="inputWidth" id="materialNeeded" value={formInputs.materialNeeded} placeholder="Enter Material needed"
             onChange={(e) =>setFormInputs({...formInputs, materialNeeded: e.target.value})}/>
           </div>
          <div className="addCHInpts">
            <label for="nutshell">Key vocabulary</label>
            <textarea type="text" className="inputWidth" id="keyVocabulary" value={formInputs.keyVocabulary} placeholder="Enter Key vocabulary"
             onChange={(e) =>setFormInputs({...formInputs, keyVocabulary: e.target.value})}/>
           </div>
          <div className="addCHInpts">
            <label for="nutshell">Assessment Options</label>
            <textarea type="text" className="inputWidth" id="assessmentOptions" value={formInputs.assessmentOptions} placeholder="Enter Assessment Options"
             onChange={(e) =>setFormInputs({...formInputs, assessmentOptions: e.target.value})}/>
           </div>
          <div className="addCHInpts">
            <label for="nutshell">Optional & Extras</label>
            <textarea type="text" className="inputWidth" id="optionalExtras" value={formInputs.optionalExtras} placeholder="Enter Optional & Extras"
             onChange={(e) =>setFormInputs({...formInputs, optionalExtras: e.target.value})}/>
           </div>
      <div className="addCHInpts">
        <label for="model3D">3D Model</label>
      {/* <select
        className="custom-select"
        name="model3D"
        value={formInputs.model3d}
        onChange={(e) =>setFormInputs({...formInputs, model3d: e.target.value})}
      >
        <option value="" disabled> Select 3D Model</option>
        {models()}
      </select> */}
      <CustomDropdown options={model3D}
       selectedd={newModel}
       type="Select 3D Model"
       model3dId={formInputs.model3dId}
       model3dName={formInputs.model3dName}
       />
      </div>
      <div className="addCHInpts">
        <label for="model3D">Curricula Type</label>
      <SelectDropdown options={curriculaTypes}
       selectedd={curricula=> setFormInputs({...formInputs, curricula: curricula.name})}
       type="Select Curricula Type"
       name={formInputs.curricula}
       />
      </div>

       <h4 className="trAttachment"> Card Image </h4>
        <div className="mrAtt">
        <FileUploader handleChange={handleImgChange} name="file" types={fileTypes} />
        <Loader loading={cardLoading} />
           {img && !cardLoading ? <img src={`${FILES_URL}${img.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>
        </div>
          <div className="addChallengeLR">
          <div className="addCHInpts">
            <label for="subject">Subject</label>
            <input type="text" className="inputWidth" id="subject" value={formInputs.subject} placeholder="Enter subject"
             onChange={(e) =>setFormInputs({...formInputs, subject: e.target.value})}/>
          </div>
     <div className="addCHInpts">
            <label for="lesson">Lesson</label>
            <input type="text" className="inputWidth" id="lesson" value={formInputs.lesson} placeholder="Enter Lesson" 
            onChange={(e) =>setFormInputs({...formInputs, lesson: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="judgingCriteria">NGSS Integration & Cross-Disciplinary Connections</label>
            <textarea type="text" className="inputWidth" id="ngssCross" value={formInputs.ngssCross} placeholder="Enter Judging Criteria" 
            onChange={(e) =>setFormInputs({...formInputs, ngssCross: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Student Project objectives</label>
            <textarea type="text" className="inputWidth" id="studentObjectives" value={formInputs.studentObjectives} placeholder="Enter Project objectives" 
            onChange={(e) =>setFormInputs({...formInputs, studentObjectives: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Teacher Project objectives</label>
            <textarea type="text" className="inputWidth" id="teacherObjectives" value={formInputs.teacherObjectives} placeholder="Enter Project objectives" 
            onChange={(e) =>setFormInputs({...formInputs, teacherObjectives: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Student Experiment steps</label>
            <textarea type="text" className="inputWidth" id="studentSteps" value={formInputs.studentSteps} placeholder="Enter Experiment steps" 
            onChange={(e) =>setFormInputs({...formInputs, studentSteps: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Teacher Experiment steps</label>
            <textarea type="text" className="inputWidth" id="teacherSteps" value={formInputs.teacherSteps} placeholder="Enter Experiment steps" 
            onChange={(e) =>setFormInputs({...formInputs, teacherSteps: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Hints & Tips</label>
            <textarea type="text" className="inputWidth" id="hintsTips" value={formInputs.hintsTips} placeholder="Enter Hints & Tips" 
            onChange={(e) =>setFormInputs({...formInputs, hintsTips: e.target.value})}/>
          </div>

        <h4 className="trAttachment"> Project Presentation </h4>
        <div className="trAttachmentDev mrAtt flex">
        <FileUploader handleChange={handlePresentation} name="file" types={presentationTypes} />
          <Loader loading={preLoading} />
           {presentation && !preLoading ? <IoCheckmarkDoneCircleSharp style={{ width: '45px', height: '45px', marginLeft: '10px', color: 'green' }}/> : null}
        </div>

       <h4 className="trAttachment"> Cover Image </h4>
        <div className="mrAtt">
        <FileUploader handleChange={handleCoverChange} name="file" types={fileTypes} />
        <Loader loading={coverLoading} />
     {cover && !coverLoading ? <img src={`${FILES_URL}${cover.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>
    </div>   
        </div>
        <div style={{textAlign:"center"}}>
        <button type="submit" disabled={!isFormValid} className="add-Challenge">Publish</button>
        </div>
       </form> 
  );
};

export default AddProject;
